<template>
  <v-row>
    <v-col
      sm="1"
      lg="2"
      class="hidden-xs-only"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            exact
            color="primary"
            v-bind="attrs" 
            v-on="on" 
            @click="regresar"
          >
            <v-icon>
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>

    <v-col 
      cols="12" 
      sm="10" 
      lg="8"
    >
      <DetailCard
        title="Detalles Competencia"
        :loading="cardLoading"
      >
        <v-row justify="center">
          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Competencia
            </p>
            <p class="text-subtitle-1">
              {{ competencia.competencia }}
            </p>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Descripción
            </p>
            <template v-if="competencia.descripcion != null">
              <p class="text-subtitle-1">
                {{ competencia.descripcion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Fecha Inicio
            </p>
            <template v-if="competencia.fecha_inicio != null">
              <p class="text-subtitle-1">
                {{ competencia.fecha_inicio }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Fecha Fin
            </p>
            <template v-if="competencia.fecha_fin != null">
              <p class="text-subtitle-1">
                {{ competencia.fecha_fin }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Lugar
            </p>
            <template v-if="competencia.lugar != null">
              <p class="text-subtitle-1">
                {{ competencia.lugar }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Dirección
            </p>
            <template v-if="competencia.direccion != null">
              <p class="text-subtitle-1">
                {{ competencia.direccion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Centro de Formación
            </p>
            <template v-if="competencia.centro_formacion != null">
              <p class="text-subtitle-1">
                {{ competencia.centro_formacion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from '../../../components/admin/DetailCard.vue'

export default {
  data: () => ({
    cardLoading: true
  }),

  components: {
    DetailCard
  },

  mounted() {
    this.$store.dispatch("obtenerCompetenciaCampesenaId", this.$route.params.idCompetencia)
    setTimeout(() => {
      this.cardLoading = false
    }, 1000)
  },

  computed: {
    competencia() {
      return this.$store.getters.obtenerCompetenciaCampesena
    }
  },

  methods: {
    regresar() {
      this.$router.back()
    }
  }
}
</script>
